export default "__VITE_ASSET__D_SJPz4T__"